import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { cardsService } from "./cardsService";

export const activateCard = async (
  cardId: string,
  request: cardApiSpec.ActivateCardRequest
): Promise<cardApiSpec.Card> => {
  const { data } = await cardsService.post(`/${cardId}/activate`, request);

  return data;
};
